import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { StandardTabs, Tab } from "@ts-digital/vrc";
import Spinner from "../../general/spinner";

import AnalyticsChart from "../../analytics/index";
import "./statisticStyle.css";
import { fixKpiTitle } from "../../../libs/lang-utils";

const StatisticsForm = () => {

  /** Evita di usare la connect ed è più performante */
  const analytics = useSelector(state => state.analytics);

  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = e => {
    setActiveTab(e);
  };

  const dataKpi =
    analytics && analytics.kpiList.status.ended ? analytics.kpiList.data : null;
  const dictionaryTitles = analytics ? analytics.kpiTitles.data : null;
  let statisticsArray = [];
  let statistics = [];
  let customTab = [];
  let titlesParentTab = [];
  let childrenList = {};
  let cont = 0;
  if (
    analytics &&
    (analytics.kpiList.status.ended || analytics.kpiList.status.error) &&
    !dataKpi
  )
    return (
      <div>
        <FormattedMessage id="analytics.noChartOnCompany" />
      </div>
    );

  if (dataKpi && dataKpi.data) {
    let counter = 0;
    for (let c = 0; c < dataKpi.data.length; c++) {
      let kpiCategories = dataKpi.data[c]["kpiScopes"];
      for (let d = 0; d < kpiCategories.length; d++) {
        if (
          kpiCategories[d].name === "lynfa.std.studio.name" ||
          kpiCategories[d].name === "sdi.std.statistiche_sdi.name"
        ) {
          continue;
        }
        counter++;
        for (let r = 0; r < kpiCategories[d].kpis.length; r++) {
          let idKpi = kpiCategories[d].kpis[r].id;
          const kpiName = kpiCategories[d].kpis[r].url;
          const parentId = kpiCategories[d].kpis[r].parentId;
          const kpiType = kpiCategories[d].kpis[r].kpiType.id;
          // esempio title: alyante.std.ciclo_attivo.fatturato_totale.title
          const analyticsTitleSplit = kpiCategories[d].kpis[r].title.split(".");
          let kpiTitle = null;
          analyticsTitleSplit.map(el => {
            kpiTitle = kpiTitle
              ? kpiTitle[el]
              : dictionaryTitles
                ? dictionaryTitles[el]
                : "";
            return kpiTitle;
          });

          if (parentId === null) {
            cont = idKpi;
            childrenList[cont] = [];
          } else if (kpiName) {
            childrenList[cont].push({ kpiName: kpiName, kpiTitle: fixKpiTitle(kpiTitle) });
          }
          const link2 = "graphId" + c + d + r;
          if (kpiName && parentId === null) {
            customTab.push(<Tab
              key={link2}
              onClick={e => {
                let elmnt = document.getElementById(link2);
                if (elmnt)
                  elmnt.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                  });
              }}
              style={{
                cursor: "pointer",
                padding: "0px 12px",
                height: "40px"
              }}
            >
              {fixKpiTitle(kpiTitle)}
            </Tab>);
          }
          if (kpiName && kpiTitle) {
            statisticsArray.push(<AnalyticsChart
              key={"key_" + c + d + r}
              anchorId={link2}
              idDivForChart={"analyticsView-chart" + kpiName}
              fromStatistics={true}
              kpiTitle={fixKpiTitle(kpiTitle)}
              kpiName={kpiName}
              childrenList={childrenList[idKpi] ? childrenList[idKpi] : null}
              parentId={parentId}
              kpiType={kpiType}
            />);
          }
        }

        statistics.splice(
          counter, 0, statisticsArray
        );
        statisticsArray = [];
        titlesParentTab.splice(
          counter, 0, customTab
        );
        customTab = [];
      }
    }

    return (
      <div style={{ backgroundColor: "#ffffff" }}>
        <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
          <StandardTabs
            style={{ marginBottom: "5px", overflow: "hidden", width: "100%" }}
            activeIndex={activeTab}
            onChange={handleTabChange}
          >
            <Tab className="styleTab" key={0}>
              <FormattedMessage id="settings.businessPerformanceSettings.clientsTitle" />
            </Tab>
            <Tab className="styleTab" key={1}>
              <FormattedMessage id="settings.businessPerformanceSettings.providersTitle" />
            </Tab>
            <Tab className="styleTab" key={2}>
              <FormattedMessage id="settings.businessPerformanceSettings.portfolioTitle" />
            </Tab>
            <Tab className="styleTab" key={3}>
              <FormattedMessage id="settings.businessPerformanceSettings.storeTitle" />
            </Tab>
            {/*  SEZIONI AL MOMENTO NON + ATTIVE!  */}
            {/* <Tab className="styleTab" key={4}>
              Contabilità
            </Tab> */}
            {/* <Tab className="styleTab" key={5}>
              Studio
            </Tab> */}
            {/* <Tab className="styleTab" key={6}>
              Statistiche SDI
            </Tab> */}
          </StandardTabs>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {titlesParentTab[activeTab]}
        </div>
        <div
          style={{
            height: "100%",
            marginTop: "5px",
            overflowX: "hidden",
            columnCount: 2
          }}
        >
          {statistics[activeTab]}
        </div>
      </div>
    );
  } else if (analytics && analytics.kpiList.status.started) {
    return (
      <Spinner
        size="large"
        tip={
          <span>
            <FormattedMessage id="generic.loadingData1"/>. <br /> <FormattedMessage id="generic.loadingData2"/>.
          </span>
        }
      />
    );
  } return null;
};

export default StatisticsForm;
